import React from "react";

function renderProcess(Component: any){
    return function Render(props: any){
        return React.createElement((({ children, onGlobalRenders }) => {
            return (<>
                {(onGlobalRenders && Object.keys(onGlobalRenders).length ) && Object.keys(onGlobalRenders)
                  .map(key => onGlobalRenders[key])
                  .map((C, key) => <C key={key} />)}
                {children}
            </>)
        }), props, React.createElement(Component, props))
    }
}

export default  renderProcess;